import { PolymerElement } from '@polymer/polymer/polymer-element.js';
import './styles.js';
import './flex.js';
import { html } from '@polymer/polymer/lib/utils/html-tag.js';
class Oauth extends PolymerElement {
  static get template() {
    return html`
    <style include="nimbus-flex"></style>
    <style include="nimbus-styles">
      @font-face {
        font-family: 'Noto Sans';
        src: url('fonts/NotoSans-Italic.eot');
        src: url('fonts/NotoSans-Italic.eot?#iefix') format('embedded-opentype'),
          url('fonts/NotoSans-Italic.woff') format('woff'),
          url('fonts/NotoSans-Italic.ttf') format('truetype');
        font-weight: normal;
        font-style: italic;
      }

      @font-face {
        font-family: 'Noto Sans';
        src: url('fonts/NotoSans-Bold.eot');
        src: url('fonts/NotoSans-Bold.eot?#iefix') format('embedded-opentype'),
          url('fonts/NotoSans-Bold.woff') format('woff'),
          url('fonts/NotoSans-Bold.ttf') format('truetype');
        font-weight: bold;
        font-style: normal;
      }

      @font-face {
        font-family: 'Noto Sans';
        src: url('fonts/NotoSans-BoldItalic.eot');
        src: url('fonts/NotoSans-BoldItalic.eot?#iefix') format('embedded-opentype'),
          url('fonts/NotoSans-BoldItalic.woff') format('woff'),
          url('fonts/NotoSans-BoldItalic.ttf') format('truetype');
        font-weight: bold;
        font-style: italic;
      }

      @font-face {
        font-family: 'Noto Sans';
        src: url('fonts/NotoSans.eot');
        src: url('fonts/NotoSans.eot?#iefix') format('embedded-opentype'),
          url('fonts/NotoSans.woff') format('woff'),
          url('fonts/NotoSans.ttf') format('truetype');
        font-weight: normal;
        font-style: normal;
      }
      .ndsgn-icon-google {
        display: block;
        width: 18px;
        height: 18px;
        background: url(images/google.svg) no-repeat 0px 0px;
      }
      .ndsgn-icon-facebook {
        display: block;
        width: 18px;
        height: 18px;
        background: url(images/facebook.svg) no-repeat 0px 0px;
      }
    </style>

    <div class="ndsgn-auth-form-other-methods-button">
      <button class="ndsgn-button ndsgn-button-full-width ndsgn-button-google-button" type="button" on-click="showGoogle">
        <span class="ndsgn-button-layout" flex="" layout="row" layout-align="center center">
          <i class="ndsgn-icon-google" flex="none"></i>
          <span flex="">Sign in with Google</span>
        </span>
      </button>
    </div>
    <div class="ndsgn-auth-form-other-methods-button">
      <button class="ndsgn-button ndsgn-button-full-width ndsgn-button-facebook-button" type="button" on-click="showFacebook">
        <span class="ndsgn-button-layout" flex="" layout="row" layout-align="center center">
          <i class="ndsgn-icon-facebook" flex="none"></i>
          <span flex="">Sign in with Facebook</span>
        </span>
      </button>
    </div>
`;
  }

  static get is() { return "oauth-buttons"; }
  static get properties() {
    return {
    }
  }

  constructor() {
    super();
  }

  show(provider) {
    let token = "";
    let providers = {
      "google": {
        size: {
          width: 500,
          height: 500
        }
      },
      "facebook": {
        size: {
          width: 500,
          height: 500
        }
      }
    };

    if(!providers[provider]) {
      return;
    }
    var left = (screen.width/2)-(providers[provider].size.width/2);
    var top = (screen.height/2)-(providers[provider].size.height/2);
    var url = "https://nimbusweb.me/auth/openidconnect.php?provider="+provider;
    if (token) url += '&token=' + token;
    window.open(url, "openid_"+provider, "left="+left+",top="+top+",width="+providers[provider].size.width+",height="+providers[provider].size.height);
  }

  showFacebook() {
    this.show("facebook");
  }

  showGoogle() {
    this.show("google");
  }
}
customElements.define(Oauth.is, Oauth);
